export default __webpack_public_path__ + "images/96b015ffbb959cb2c94dfa563a88bec3.svg";